import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Container, Col, Row } from "react-bootstrap";
import "react-bootstrap-typeahead/css/Typeahead.css";
import SearchBarAdvisor from "../common/SearchBarAdvisor";
import SearchBar from "../common/SearchBar";
import ErrorBoundary from "./ErrorBoundry";

interface StudentSearchState
{
    options?: Student[];
    isLoading: boolean;
}

class StudentSearch extends React.Component<any, StudentSearchState>
{

    render(): React.ReactNode 
    {
        return <div style={{ marginTop: 100 + "px" }}>
            <ErrorBoundary>
                <h2 className="text-center">Welcome to Canopy</h2>
                {
                    this.props.role == "academicAdvisor"
                        ?
                        <h3 className="text-center" style={{ color: "grey" }}>Please select a Student Advisee</h3>
                        :
                        <h3 className="text-center" style={{ color: "grey" }}>To begin, search for a student</h3>
                }
                <div className="typeahead mx-auto d-block col-xs-12 col-md-6">
                    {
                        (this.props.role == "academicAdvisor")
                            ?
                            <SearchBarAdvisor isTopBar={false} />
                            :
                            <SearchBar />
                    }
                </div>
            </ErrorBoundary>
        </div>;
    }
}

const mapStateToProps = (state: any) => ({
    role: state.app.user.role
});

export default connect(mapStateToProps)(StudentSearch);